export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const PROMPT_NO_ACCESS = 'PROMPT_NO_ACCESS'
export const CLOSE_NO_ACCESS = 'CLOSE_NO_ACCESS'
